module.exports = __webpack_public_path__ + "img/DerSong2.eab7ae04.svg";